import { render, staticRenderFns } from "./ItemizerCanvas.vue?vue&type=template&id=b4b49dec&scoped=true&"
import script from "./ItemizerCanvas.vue?vue&type=script&lang=js&"
export * from "./ItemizerCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ItemizerCanvas.vue?vue&type=style&index=0&id=b4b49dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b49dec",
  null
  
)

export default component.exports